import {Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges, HostListener, ViewChild, ElementRef} from '@angular/core';
import {Donation} from "../donation/donation";
import {ShopCartService} from "../shop/shop.cart.service";
import {Product} from "../shop/shop.product.model";
import {DecimalPipe} from "@angular/common";
import {UrlService} from "../url/url.service";

declare let __twingle_products: any;

@Component({
    selector: 'giftshop-list',
    templateUrl: './giftshop.list.component.html',
    providers: [DecimalPipe]
})
export class GiftshopListComponent implements OnInit, OnChanges {

    /**
     * The current donation
     */
    @Input() donation: Donation;

    /**
     * The current widget size
     */
    @Input() size: string;

    /**
     * Output parameter for changing the step
     * @type {EventEmitter}
     */
    @Output() stepChange: EventEmitter<string> = new EventEmitter();

    /**
     * Holds the current list DOM element
     */
    @ViewChild('listElement') listElement: ElementRef;

    /**
     * list of available products
     */
    products: Product[];

    /**
     * the active product
     */
    activeProduct: Product;

    /**
     * List of placeholders for the button to show the chart.
     */
    buttonPlaceholder: {items: number, price: string, currency: string} = {items: 0, price: '0', currency: ''};

    /**
     * the currently pisible page in the items pagination
     */
    page: number = 1;

    /**
     * number of items we want to show per page in the item pagination
     */
    itemsPerPage: number = 0;

    /**
     * The available screensizes we want to check for
     */
    itemsPerPageAndSize: any = {
        small: 8,
        medium: 8,
        large: 9,
        xlarge: 12
    }

    /**
     * Toggle for showing the categories as DropDown
     */
    showCategoryDropDown: boolean = false;

    /**
     * constructor
     * @param cartService
     * @param decimalPipe
     * @param urlService
     */
    constructor(private cartService: ShopCartService, private decimalPipe: DecimalPipe, private urlService: UrlService) {}

    /**
     * @inheritDoc
     */
    ngOnInit(): void {
        // get products and categories to show
        this.products = [];
        if(typeof  __twingle_products != "undefined" && __twingle_products.length > 0) {
            this.products = __twingle_products;
        }

        // init the list of placeholders
        this.updatePlaceHolderAndAmount();

        // on changes in the chart, we need to do a few things.
        this.cartService.itemsUpdated.subscribe(() => this.updatePlaceHolderAndAmount());

        // set items per page initially
        this.updateItemsPerPage();
    }

    /**
     * @inheritDoc
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges) {
        if(changes.hasOwnProperty("size") && changes.size.isFirstChange() === false) {
            // on size change, change the number of visible items.
            this.updateItemsPerPage();
        }
    }

    /**
     * Updates the items per page that we want to show
     */
    updateItemsPerPage(): void {
        if(this.itemsPerPageAndSize.hasOwnProperty(this.size)) {
            this.itemsPerPage = this.itemsPerPageAndSize[this.size];
        }
    }

    /**
     * Updates the placeholder data for the button and its teaser.
     */
    updatePlaceHolderAndAmount(): void {
        // update placeholder as whole item because chage detection will not work aotherwise
        this.buttonPlaceholder = {
            items: this.cartService.getOverallCount(),
            price: this.decimalPipe.transform(this.cartService.getPrice(), '1.0-0'),
            currency: this.donation.currencySymbol
        };
        // update the price of the donation
        this.donation.amount = this.cartService.getPrice();
    }

    /**
     * change the current step because of cart or details is called.
     * @param newStep
     */
    changeStep(newStep: string): void {
        this.stepChange.emit(newStep);
    }

    /**
     * Sets an active item
     * @param product
     */
    setActiveItem(product: Product): void {
        this.activeProduct = product;
    }

    /**
     * Deactivate the current selected item. Also if the user clicks somewhere else than on an item in the list.
     * @param event
     */
    @HostListener('document:click', ['$event'])
    deactivateItem(event): void {
        if(event) {
            // do nothing if the user clicks inside one list item
            for (let i = 0; i < this.listElement.nativeElement.children.length; i++) {
                if(this.listElement.nativeElement.children[i].contains(event.target)) {
                    return;
                }
            }
        }
        this.activeProduct = null;
    }

    /**
     * if an item is set/added to the chart, call this function.
     * @param item
     */
    addItemToChart(item: {product: Product, count: number, price: number}): void {
        this.cartService.addItem(item.product, item.count, false, item.price);
        this.changeStep("cart");
    }
}
